// Licensed to Elasticsearch B.V. under one or more contributor
// license agreements. See the NOTICE file distributed with
// this work for additional information regarding copyright
// ownership. Elasticsearch B.V. licenses this file to you under
// the Apache License, Version 2.0 (the "License"); you may
// not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

'use strict'

const { toString } = Object.prototype

// Format an Error instance into ECS-compatible fields on the `ecs` object.
// https://www.elastic.co/guide/en/ecs/current/ecs-error.html
// Return true iff the given `err` was an Error object that could be processed.
function formatError (ecsFields, err) {
  if (!(err instanceof Error)) {
    ecsFields.err = err
    return false
  }

  ecsFields.error = {
    type: toString.call(err.constructor) === '[object Function]'
      ? err.constructor.name
      : err.name,
    message: err.message,
    stack_trace: err.stack
  }

  return true
}

module.exports = { formatError }
